export const webData = state => state.webData

export const gradeOptions = state => state.gradeOptions

export const userinfo = state => state.userinfo

export const room_id = state => state.room_id

export const wechat_token = () => localStorage.getItem('wechat_token')

// export const access_token = state => {
//   console.log(state)
//   if (localStorage.getItem('access_token')) {
//     console.log('000')
//     return localStorage.getItem('access_token')
//   } else {
//     console.log('999')
//     return state.access_token
//   }
// }

export const access_token = () => localStorage.getItem('access_token')

export const stage_list = state => state.stage_list

export const pkType = state => state.pkType
